import { createSelector } from '@ngrx/store';
import { BoelsState, getStoreState } from '../../reducers.index';

export const selectActiveCategory = createSelector(
  getStoreState,
  (state: BoelsState) => state.categories.active,
);

export const selectActiveCategoryListingPage = createSelector(
  getStoreState,
  (state: BoelsState) => state.categories.activeListingPage,
);
